import { getMetaSiteId } from '../store/instance-values/instance-values-selectors';
import { type AppState } from '../types';

export const getIframeSandboxDomain = (state: AppState) =>
  `https://${getMetaSiteId(state)}.usrfiles.com`;
